import React, { Component }        from 'react';
import { withRouter }              from 'react-router';
import { connect as reduxConnect } from 'react-redux';
import { Card, Modal, Badge }      from 'react-bootstrap';
import { FaPaperPlane }            from 'react-icons/fa';
import { FaEject }                 from 'react-icons/fa';
import { FaPlug }                  from 'react-icons/fa';
import Time                        from 'react-time';
import PubSub                      from 'pubsub-js';
import { ClipLoader }              from 'react-spinners';
import Linkify                     from 'react-linkify';
import { ConnectConstants }        from '../environment';
import { isLoggedIn }              from '../../../../utils/authService';
import { connectChatFetchData }    from '../../../../actions/connect/chat';
import { connectTokenFetchData }   from '../../../../actions/connect/token';
import { connectOfflineFetchData } from '../../../../actions/connect/offline';

var apiHost          = ConnectConstants.WebApiHost;
var tokenMessage     = 'Please enter the one-time token sent to ##TOKEN## to proceed.';
var connMessage      = 'One moment while we connect you to a representative.';
var offlineMessage   = 'If you would like to send us a message, we would love to hear from you.';
var offlineError     = 'Looks like that department is offline. Please choose a new department or try again later.';
var offlineSuccess   = 'Thank you for your message.';
var offlineSendError = 'Could not send your message, please try again later.';
var generalError     = 'Could not establish a chat connection, please try again. If the problem persists, please wait and try again later.';

class Chat extends Component {
  constructor(props) {
    super(props);
    this.state = { 
      chat           : false,
      token          : false,
      show           : false,
      message        : '',
      offlineMessage : '',
      anonymousAuth  : '',
      messages       : []
    };
    
    this.handleMessageChange   = this.handleMessageChange.bind(this);
    this.handleMessageKeyDown  = this.handleMessageKeyDown.bind(this);
    this.handleOfflineKeyDown  = this.handleOfflineKeyDown.bind(this);
    this.fetchAnonymous        = this.fetchAnonymous.bind(this);
    this.sendMessage           = this.sendMessage.bind(this);
    this.sendOffline           = this.sendOffline.bind(this);
    this.disconnect            = this.disconnect.bind(this);
    this.subscriber            = this.subscriber.bind(this);
    this.closeChat             = this.closeChat.bind(this);
    this.openChat              = this.openChat.bind(this);
  }
  
  componentWillUnmount(){
    PubSub.unsubscribe(this.token);
    PubSub.unsubscribe(this.tokenA);
    PubSub.unsubscribe(this.tokenB);
    PubSub.unsubscribe(this.tokenC);
    PubSub.unsubscribe(this.tokenD);
    PubSub.unsubscribe(this.tokenE);
  }

  componentDidMount() {  
    console.log('new chat loaded');
    console.log(JSON.stringify(this.props.currentChatId));
    this.token  = PubSub.subscribe('connect.chat.response',       this.subscriber.bind(this));
    this.tokenA = PubSub.subscribe('connect.chat.error',          this.subscriber.bind(this));
    this.tokenB = PubSub.subscribe('connect.chat.token',          this.subscriber.bind(this));
    this.tokenC = PubSub.subscribe('connect.chat.token.error',    this.subscriber.bind(this));
    this.tokenD = PubSub.subscribe('connect.chat.offline.result', this.subscriber.bind(this));
    this.tokenE = PubSub.subscribe('connect.chat.offline.error',  this.subscriber.bind(this));
    
    if (!this.props.currentChatId.Online) {
      var messages = [];
      var offlineMsg = offlineError;
      if (this.props.currentChatId.Offline && this.props.currentChatId.Offline.Message) {
        offlineMsg = this.props.currentChatId.Offline.Message;
      }
      
      if (this.props.currentChatId.Offline && this.props.currentChatId.Offline.CanBeContactedOffline && this.props.currentChatId.Offline.Email) {
        this.setState({
          chat: true,
          show: true,
          messages: messages.concat(
          {
            incoming: true,
            date: new Date(),
            message: offlineMsg
          },
          {
            incoming: true,
            date: new Date(),
            message: offlineMessage
          })
        });
      }
      else {
        this.setState({
          chat: true,
          show: true,
          messages: messages.concat(
          {
            incoming: true,
            date: new Date(),
            message: offlineMsg
          })
        });
      }
    }
    else {    
      if (isLoggedIn()) {
        this.setState({
          authenticated: true,
          chat: true,
          show: true,
          messages: this.state.messages.concat({
            incoming: true,
            date: new Date(),
            message: connMessage
          })
        }, function() {
          this.props.fetchData(apiHost, this.props.currentChatId.ConnectInstanceId, this.props.currentChatId.ConnectFlowId);
        });
      }
      else {
        var message = tokenMessage.replace("##TOKEN##", this.props.email);
        if (this.props.anonymousAuth || this.state.anonymousAuth) {
          message = connMessage;
        }
        
        this.setState({
          authenticated: false,
          chat: true,
          show: true,
          messages: this.state.messages.concat({
            incoming: true,
            date: new Date(),
            message: message
          })
        }, function() {
          if (this.props.anonymousAuth || this.state.anonymousAuth) {
            this.fetchAnonymous();
          }
          else {
            this.props.fetchDataToken(apiHost, this.props.email);
          }
        });
      }
    }
  }
  
  componentDidUpdate(prevProps) {
    if (document.getElementById("msg_history")) {
      var element = document.getElementById("msg_history");
      element.scrollTop = element.scrollHeight;
    }
  }
  
  ///////////////////
  // CHAT METHODS //
  //////////////////
  
  closeChat() {
    if (this.state.chatSession) {
      try {
        this.state.chatSession.sendEvent({ contentType: 'application/vnd.amazonaws.connect.event.participant.left' });    
      }
      catch(ex) { }
    }
    
    this.setState({
      chat: false,
      show: false
    }, function() {
      PubSub.publish('connect.chat.ui.chatClose');
    });
  }
  
  openChat() {
    if (document.getElementById("write_msg")) {
      document.getElementById("write_msg").focus();
    }
  }
  
  disconnect() {
    this.props.disconnect(this.props.currentChatId.Id);
    this.closeChat();
  }
  
  fetchAnonymous(message) {
    var anonymousAuth = this.props.anonymousAuth;
    if (this.state.anonymousAuth) {
      anonymousAuth = this.state.anonymousAuth;  
    }
    
    this.props.fetchData(apiHost, this.props.currentChatId.ConnectInstanceId, this.props.currentChatId.ConnectFlowId, this.props.email, 
      { 
        Username       : this.props.email, 
        CustomerName   : this.props.name, 
        StudentID      : this.props.studentId,
        Authentication : anonymousAuth,
        OTPToken       : message
      }
    );
  }
  
  fetchOffline(message) {
    var anonymousAuth = this.props.anonymousAuth;
    if (this.state.anonymousAuth) {
      anonymousAuth = this.state.anonymousAuth;  
    }
    
    this.props.fetchDataOffline(apiHost, 
      {
        Id        : this.props.currentChatId.Id,
        Message   : this.state.offlineMessage,
        Username  : this.props.email,
        Attributes: {
          Username       : this.props.email, 
          CustomerName   : this.props.name, 
          StudentID      : this.props.studentId,
          Authentication : anonymousAuth,
          OTPToken       : message
        }
      }
    );
  }
  
  sendMessage() {
    if (this.state.message) {
      if (this.state.chatSession && !this.state.token) {      
        this.state.chatSession.sendMessage({
          message: this.state.message,
          contentType: 'text/plain'
        })
        .then(() => {
          this.setState({
            message: ''
          });
        });
      }
      else {
        if (!isLoggedIn()) {
          var message = this.state.message;
          this.setState({
            messages: this.state.messages.concat({
              incoming: false,
              date: new Date(),
              message: this.state.message
            })
          }, function() {
            this.setState({
              message: ''
            });
            
            this.fetchAnonymous(message);
          });
        }
      }
    }
  }
  
  sendOffline() {
    var message = this.state.message;
    if (!isLoggedIn()) {
      this.setState({
        messages: this.state.messages.concat({
          incoming: false,
          date: new Date(),
          message: this.state.message,
          displayName: this.props.email
        })
      }, function() {
        var msg = this.state.offlineMessage;
        if (!msg) {
          msg = message;  
        }
        
        this.setState({
          message: '',
          offlineMessage: msg
        }, function() {
          this.fetchOffline(message);
        });
      });
    }
    else {
      this.setState({
        messages: this.state.messages.concat({
          incoming: false,
          date: new Date(),
          message: this.state.message
        })
      }, function() {
        this.setState({
          message: ''
        });
        
        this.props.fetchDataOffline(apiHost, {
          Id: this.props.currentChatId.Id,
          Message: message
        });
      });
    }
  }
  
  subscriber(msg, data) {
    if (msg === "connect.chat.response") {
      var args = {
        chatDetails: {
          ContactId: data.startChatResult.ContactId,
          ParticipantId: data.startChatResult.ParticipantId,
          ParticipantToken: data.startChatResult.ParticipantToken
        },
        type: window.connect.ChatSession.SessionTypes.CUSTOMER,
        options: {
          region: 'us-west-2'
        }
      };

      var chatSession = window.connect.ChatSession.create(args);    
      this.setState({
        token    : false,
        messages : [{
          incoming: true,
          date: new Date(),
          message: connMessage
        }],
        chatSession: chatSession
      }, function() {
        this.establishChat(data);
        PubSub.publish('connect.chat.ui.stateChange', {
          chatSession : chatSession
        });
      });
    }
    else if (msg === "connect.chat.token") {
      this.setState({
        token: true
      });
    }
    else if (msg === "connect.chat.token.error") {
      
    }
    else if (msg === "connect.chat.error") {
      if (!this.state.authenticated) {
        this.setState({
          messages: [{
            incoming: true,
            date: new Date(),
            message: tokenMessage.replace("##TOKEN##", this.props.email)
          }]
        }, function() {
          this.props.fetchDataToken(apiHost, this.props.email);
        });
      }
      else {
        var messages = [];
        this.setState({
          messages: messages.concat({
            incoming: true,
            date: new Date(),
            message: generalError
          })
        });
      }
    }
    else if (msg === "connect.chat.offline.result") {
      this.setState({
        offlineMessage: '',
        anonymousAuth: data.Authentication,
        messages: [...this.state.messages, 
        {
            incoming: true,
            date: new Date(),
            message: offlineSuccess
        }]
      });
      
      if (data.Authentication) {
        PubSub.publish('connect.chat.attributes', {
          anonymousAuth: data.Authentication
        });
      }
    }
    else if (msg === "connect.chat.offline.error") {
      var issueToken = false;
      if (data.input) {
        var payload = JSON.parse(data.input);
        if (payload && payload.OTPToken === true) {
          issueToken = true;
        }
      }
      
      if (!issueToken) {
        this.setState({
          messages: [...this.state.messages, 
          {
              incoming: true,
              date: new Date(),
              message: offlineSendError
          }]
        });
      }
      else {
        this.setState({
          messages: [...this.state.messages, 
          {
            incoming: true,
            date: new Date(),
            message: tokenMessage.replace("##TOKEN##", this.props.email)
          }]
        }, function() {
          this.props.fetchDataToken(apiHost, this.props.email);
        });
      }
    }
  }
  
  establishChat(data) {
    this.state.chatSession.connect()
      .then((response) => {
        if (data.initialConnection === false) {
          this.state.chatSession.sendEvent({ contentType: 'application/vnd.amazonaws.connect.event.participant.joined' });  
        }
        
        this.state.chatSession.getTranscript({
          mostRecent: 50
        })
          .then((tr) => {
            if (tr.data.Transcript && tr.data.Transcript.length > 0) {
              var trList = [];
              tr.data.Transcript.forEach(transcript => {
                if (transcript.Content) {
                  trList.push({
                    incoming: transcript.ParticipantRole === "CUSTOMER" ? false : true,
                    date: new Date(transcript.AbsoluteTime),
                    message: transcript.Content,
                    displayName: transcript.DisplayName
                  });
                }
              });
              
              this.setState({
                messages: trList
              });
            }
          })
          .catch((error) => {
            console.log(error);
            this.props.disconnect(this.props.currentChatId.Id);
            this.setState({
              currentChatId: {}
            }, function() {
              this.changeChat(this.props.currentChatId);
            });
          });

          this.state.chatSession.onTyping(dt => {
            var hasTyping = false; // to only print one 'is typing' message
            for(var i = 0; i < this.state.messages.length; i++) {
              if(this.state.messages[i]?.typing) {
                hasTyping = true;
              }
            }
            if(!hasTyping) {
              this.setState({
                messages: this.state.messages.concat({
                  incoming: dt.data.ParticipantRole === "CUSTOMER" ? false : true,
                  date: new Date(dt.data.AbsoluteTime),
                  message: dt.data.DisplayName+" is typing...",
                  displayName: dt.data.DisplayName,
                  typing: true
                })
              });
            }
          });

          this.state.chatSession.onMessage(dt => {
            console.log('message');
            for(var i = 0; i < this.state.messages.length; i++) {
              if(this.state.messages[i]?.typing && dt.data.ParticipantRole !== "CUSTOMER") {
                this.state.messages.splice(i,1); // remove is Typing message from array
                break;
              }
            }
            if (dt.data.Content) {
              this.setState({
                messages: this.state.messages.concat({
                  incoming: dt.data.ParticipantRole === "CUSTOMER" ? false : true,
                  date: new Date(dt.data.AbsoluteTime),
                  message: dt.data.Content,
                  displayName: dt.data.DisplayName
                })
              });
            }
          });
        })
      .catch((error) => {
        console.log(error);
        console.log('Could not establish chat');
        this.props.disconnect(this.props.currentChatId.Id);
        var messages = [];
        this.setState({
          messages: messages.concat({
            incoming: true,
            date: new Date(),
            message: generalError
          })
        });
        
        console.log(JSON.stringify(this.state.chatSession.getChatDetails()));
      });
  }
  
  ////////////////////////
  // KEY/HELPER METHODS //
  ////////////////////////
  
  handleMessageChange(e) {
    this.setState({message: e.target.value});
  }
  
  handleMessageKeyDown(e) {
    if (e.key === 'Enter') {
      e.preventDefault();
      e.stopPropagation();
      this.sendMessage();
    }
  }
  
  handleOfflineKeyDown(e) {
    if (e.key === 'Enter') {
      e.preventDefault();
      e.stopPropagation();
      this.sendOffline();
    }
  }

  render() {
    const componentDecorator = (href, text, key) => (
      <a className='bronco-talk-incoming-link' href={href} key={key} target='_blank' rel='noopener noreferrer'>
        {text}
      </a>
    );
    
    return (
      <div>
        { this.state.chat ?
          <Modal
            show={this.state.show}
            onHide={() => this.closeChat()}
            onEntered={() => this.openChat()}
            dialogClassName="modal-90w bronco-talk-modal"
            aria-labelledby="bronco-talk-custom-modal-styling-title"
          >
            <Modal.Header closeButton>
              <Modal.Title id="bronco-talk-custom-modal-styling-title">
                {this.props.currentChatId.Title}
              </Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <div id="chat-frame">
                <div>
                  <img style={{ marginBottom: '20px', marginRight: '5px' }} alt="boise state" src="https://www.boisestate.edu/wp-content/themes/core/img/theme/logos/boisestate-b-logo.svg" width="50" height="50" />
                  {
                    this.props.currentChatId.Id && this.props.currentChatId.Online ?
                    <FaPlug title='Current active chat' style={{ marginTop: '-10px', marginLeft: '5px' }} size={18} />
                    :
                    <span />
                  }
                  {
                    this.props.currentChatId.Online ? 
                    <Badge title='Online' variant="success">Online</Badge>
                    :
                    <Badge title='Offline' variant="danger">Offline</Badge>
                  }
                </div>
                <Card style={{ margin: '0 0 20px 0' }}>
                  <Card.Body>
                    <div id="mesgs" className="mesgs">
                      <div id="msg_history" className="msg_history">
                        { this.props.chatIsLoading || this.state.messages.length === 0 ?
                          <div style={{ marginRight: 'auto', marginLeft: 'auto', width: '5em' }}>
                            <ClipLoader
                              color={'#072659'} 
                              loading={this.props.chatIsLoading} 
                            />
                          </div>
                          :
                          this.state.messages.map((element, index) => (
                           element.incoming ? 
                             <div className="incoming_msg" key={index} data-private>
                                <div className="received_msg">
                                   <div className="received_withd_msg">
                                      <Linkify componentDecorator={componentDecorator}>
                                        <p style={{ color: '#141827' }} className='t-content para-sm'>{element.message}</p>
                                      </Linkify>
                                      <span className="time_date"> {element.displayName}</span>
                                      <span className="time_date"> <Time value={element.date} format="HH:mm A" /> | <Time value={element.date} format="MMMM DD" /></span>
                                   </div>
                                </div>
                             </div>
                             :
                             <div className="outgoing_msg" key={index} data-private>
                                <div className="sent_msg">
                                  <p className='t-content para-sm'>{element.message}</p>
                                  <span className="time_date"> {element.displayName}</span>
                                  <span className="time_date"> <Time value={element.date} format="HH:mm A" /> | <Time value={element.date} format="MMMM DD" /></span>
                                </div>
                             </div>
                          ))
                        }
                        </div>
                        { this.props.currentChatId.Online ? 
                          <div className="type_msg" data-private>
                            <div className="input_msg_write">
                              <input id='write_msg' onKeyDown={this.handleMessageKeyDown} value={this.state.message} onChange={this.handleMessageChange} type="text" className="write_msg" placeholder="Type a message..." />
                              <button onClick={this.sendMessage} className="msg_send_btn" type="button"><FaPaperPlane style={{ marginBottom: '2px', marginRight: '2px' }} /></button>
                            </div>
                          </div>
                          :
                          <span></span>
                        }
                        { !this.props.currentChatId.Online && this.props.currentChatId.Offline && this.props.currentChatId.Offline.CanBeContactedOffline && this.props.currentChatId.Offline.Email ? 
                          <div className="type_msg" data-private>
                            <div className="input_msg_write">
                              <input id='write_msg' onKeyDown={this.handleOfflineKeyDown} value={this.state.message} onChange={this.handleMessageChange} type="text" className="write_msg" placeholder="Type a message..." />
                              <button onClick={this.sendOffline} className="msg_send_btn" type="button"><FaPaperPlane style={{ marginBottom: '2px', marginRight: '2px' }} /></button>
                            </div>
                          </div>
                          :
                          <span></span>
                        }
                    </div>
                  </Card.Body>
                  <Card.Footer>
                    <small className="text">
                    {
                      this.props.currentChatId.Online ? 
                      <span>Online &nbsp;</span>
                      :
                      <span>Offline &nbsp;</span>
                    }
                    {
                      this.props.currentChatId.Id && this.props.currentChatId.Online ?
                      <a href="/#/connect" title='Connected, click to disconnect' onClick={() => this.disconnect()}>
                        Click here to end chat session
                        <FaEject style={{ marginTop: '-10px', marginLeft: '5px' }} size={18} />
                      </a>
                      :
                      <span />
                    }
                    </small>
                  </Card.Footer>
                </Card>
              </div>
            </Modal.Body>
          </Modal>
          :
          <span></span>
        }
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    connectChat: state.connect.connectChat.connectChat,
    chatHasErrored: state.connect.connectChat.connectChatHasErrored,
    chatIsLoading: state.connect.connectChat.connectChatIsLoading
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    fetchData:        (host, instanceId, flowId, userName, attributes) => dispatch(connectChatFetchData(    host, instanceId, flowId, userName, attributes)),
    fetchDataToken:   (host, userId)                                   => dispatch(connectTokenFetchData(   host, userId)),
    fetchDataOffline: (host, message)                                  => dispatch(connectOfflineFetchData( host, message))
  };
};

export default withRouter(reduxConnect(mapStateToProps, mapDispatchToProps)(Chat));
